import { io } from "socket.io-client";


const SOCKET_URL = process.env.REACT_APP_DOMAIN;


const socket = io(SOCKET_URL, {
    transports: ['websocket'],
    autoConnect: true
})

export const EVENTS = {
    CREATE_ROOM: "_createRoomWithCb"
}

class SocketIo {
    connectToSocket = (api_token, callback = () => { }) => {
        socket.io.opts.query = {
            authorization: api_token
        }
        socket.connect();
        socket.on('connect', () => {
            callback()
        })

        socket.on('connect_error', function () {
            console.log('Connection Failed');
        });
    }
    emit = (eventName, params = {}, onSuccess) => {
        socket.emit(eventName, params, res => {
            onSuccess(res.data);
        })

    }

    on = (eventName, callback) => {
        socket.on(eventName, callback)
    }


    dispose = (eventName) => {
        socket.off(eventName);
    }

    disconnect = () => {
        socket.disconnect();
    }

    getStatus = () => {
        return socket.connected
    }
}

export default new SocketIo();